import { IEmployee, EmployeesService, DeclarationService, IShift, ShiftService } from '../../services';
import * as moment from 'moment';

class TimesheetsDashboardController implements ng.IComponentController {
    private sortType: string;
    private startDate: any;
    private endDate: any;
    private employees: IEmployee[];
    private currentEmployee: IEmployee;
    private moment: any;
    private summary: any;

    constructor(private EmployeesService: EmployeesService,
                private DeclarationService: DeclarationService,
                private ShiftService: ShiftService,
                private $stateParams: ng.ui.IStateParamsService) {
        'ngInject';
    }

    $onInit = () => {
        this.moment = require('moment');

        this.sortType = 'employeeName';

        this.startDate = this.moment().startOf('isoweek').format("YYYY-MM-DD");
        this.endDate = this.moment().endOf('isoweek').format("YYYY-MM-DD");

        this.DeclarationService.subscribe('TimesheetsDashboardController', (type) => {
            var currentShift: IShift;
            if (!this.currentEmployee || !this.DeclarationService.item) {
                return;
            }
            currentShift = this.currentEmployee.shifts.find(s => s.id == this.DeclarationService.item.shiftId);
            if (!currentShift) {
                return;
            }
            switch (type) {
                case 'post': {
                    this.updateShiftDeclarationsSummary(currentShift);
                    break;
                }
                case 'put': {
                    this.updateShiftDeclarationsSummary(currentShift);
                    break;
                }
                case 'delete': {
                    currentShift.declarations = currentShift.declarations.filter(s => s.id !== this.DeclarationService.item.id);
                    this.updateShiftDeclarationsSummary(currentShift);
                    break;
                }
            }
        });

        // this.getTimesheets();
        this.checkCompletionStatus();
    }

    // public $onChange = (change) => {
    //     console.log(change);
    // }

    public $onDestroy = () => {
        this.DeclarationService.unsubscribe('TimesheetsDashboardController');
    }


    updateShiftDeclarationsSummary(currentShift) {
        this.ShiftService.customGet(this.DeclarationService.item.shiftId + '/shiftDeclarations').then((result) => {
            currentShift.plannedHours = result.plannedHours;
            currentShift.declaredHours = result.declaredHours;
            currentShift.hoursDifference = result.hoursDifference;
            if (result.declarations) {
                currentShift.declarations = result.declarations;
                currentShift.declarationsApproved = currentShift.declarations.length > 0 &&
                    currentShift.declarations.every((d) => d.status == 3);
            }

            this.EmployeesService.customGet(this.DeclarationService.item.employeeId + '/employeeSummary', {from: this.startDate, till: this.endDate}).then((summary) => {
                this.currentEmployee.shiftHours = summary.shiftHours;
                this.currentEmployee.shiftDeclarationHours = summary.shiftDeclarationHours;
            });

            this.checkEmployeeCompletionsStatus(this.currentEmployee);
        });
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    checkCompletionStatus() {
        this.employees.forEach(e => {
            this.checkEmployeeCompletionsStatus(e);
        });
    }

    checkEmployeeCompletionsStatus(employee) {
        // console.log('checkEmployeeCompletionsStatus')
        employee.doneShiftCount = employee.shifts.filter(s => s.declarations.length > 0).length;

        employee.declarationsApproved = true;
        employee.shifts.forEach(s => {
            s.declarations.forEach(d => {
                if (d.status != 3) {
                    employee.declarationsApproved = false;
                }
            });
        });
    }

    getTimesheets() {
        this.EmployeesService.customAll('employeeSummary', {from: this.startDate, till: this.endDate}).then((result: Restangular.ICollection) => {
            this.employees = result;
            this.checkCompletionStatus();
        });
    }

    prevWeek() {
        this.startDate = this.moment(this.startDate).add(-7, 'day').format("YYYY-MM-DD");
        this.endDate = this.moment(this.endDate).add(-7, 'day').format("YYYY-MM-DD");
        this.currentEmployee = null;
        this.getTimesheets();
    }
    
    nextWeek() {
        this.startDate = this.moment(this.startDate).add(7, 'day').format("YYYY-MM-DD");
        this.endDate = this.moment(this.endDate).add(7, 'day').format("YYYY-MM-DD");
        this.currentEmployee = null;
        this.getTimesheets();
    }

    selectEmployee(item) {
        this.currentEmployee = item;
    }

    sendToNmbrs() {
        var start = this.startDate.getFullYear() + '-' + this.startDate.getMonth() + '-' + this.startDate.getDate();
        var end = this.endDate.getFullYear() + '-' + this.endDate.getMonth() + '-' + this.endDate.getDate();
        this.DeclarationService.customGet('pushtonmbrs', {from: start, till: end});
    }
}

export const timesheetsDashboardComponent : ng.IComponentOptions = {
    controller: TimesheetsDashboardController,
    bindings: {
        employees: '='
    },
    template: require('./timesheets.dashboard.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheets.dashboard.component.ts